module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl1-50.4b4199cc.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl1-50.png
// module id = 3562
// module chunks = 11